import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { PrismDataBar } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { inc } from '@nullvoxpopuli/ember-composable-helpers';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import { and, eq, not, or } from 'ember-truth-helpers';
import { IncrementFor } from 'frontend-utils';
import { RI_BREAKDOWNS } from 'frontend-utils/utils/constants/constant-values';
import GeneralButtonsButtonExpandArrow from 'lumen/components/general/buttons/button-expand-arrow';
import HotelAndMarketRevenueInsightBaseSegmentationBlockItemBase from 'lumen/components/hotel-and-market/revenue-insight/base/segmentation-block-item-base';
import HotelAndMarketRevenueInsightSegmentationSegmentationItemWithChange from 'lumen/components/hotel-and-market/revenue-insight/segmentation/segmentation-item-with-change';
import HotelAndMarketRevenueInsightTooltipsTooltipRevenueInsight from 'lumen/components/hotel-and-market/revenue-insight/tooltips/tooltip-revenue-insight';
import { AMOUNT_OF_BLOCKS_PER_ROW } from 'lumen/utils/constants/ri-constant-values';
// @ts-expect-error: Incorrect type
import { hasActiveChildren } from 'lumen/utils/filter-bar/filter-functions';
import tooltipSideCalculation from 'lumen/utils/tooltip-utils';

// @ts-expect-error: Incorrect type
export default class HotelAndMarketRevenueInsightSegmentationSegmentationItem extends HotelAndMarketRevenueInsightBaseSegmentationBlockItemBase {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get changeData() {
    return {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      value: this.changeValue,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      formattedValue: this.formattedChangeValueWithPercentage,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      positiveWidthPercentage: this.positiveReferenceValuePercentage,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      negativeWidthPercentage: this.negativeReferenceValuePercentage,
    };
  }

  @computed('args.{params.expandedIds.[],item.segmentationValueId}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isExpanded() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.params?.expandedIds?.includes(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.args.item?.segmentationValueId,
    );
  }

  @computed('args.params.segmentationName')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isPickup() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.args.params?.segmentationName === RI_BREAKDOWNS.PICKUP;
  }

  @computed('args.item.children')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showExpandableArrow() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(this.args.item?.children);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showPercentages() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.riSelections?.isCancellationsPercentageView;
  }

  @computed('args.item.hasNoData')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showSimplifiedTemplate() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.item?.hasNoData;
  }

  @computed('args.params.segmentationBlockIdx')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipSide() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const indexOfSegmentationItem = this.args.params?.segmentationBlockIdx;
    return tooltipSideCalculation(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      indexOfSegmentationItem,
      AMOUNT_OF_BLOCKS_PER_ROW,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get vsReferencePeriodText() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.riSelections.getVsReferencePeriodText(this.isPickup);
  }

  @action
  activateSearch(): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.scrollToTop();
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.params.updateIsSearchActive(true);
  }

  @action
  // @ts-expect-error: Incorrect type
  toggleExpandedRow(segmentationItem): void {
    // Only toggle expand if the item doesn't have nested children in the filters.
    if (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      !hasActiveChildren(
        segmentationItem,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.args.params.parsedSegmentationFilters,
      )
    ) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.args.params.updatedExpandedParents(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        segmentationItem.segmentationValueId,
      );
      // Scroll down if a row is being expanded
      if (!this.isExpanded) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (segmentationItem.isLastRow) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.args.scrollDownOnItemExpand();
        }
      }
    }
  }

  <template>
    {{! template-lint-disable no-nested-interactive require-presentational-children }}
    <div
      class="block-list-item-container block-list-item-container--segmentation
        {{if this.isSelected ' segmentation-item--selected'}}
        {{if @item.isSelectable ' segmentation-item--selectable'}}
        {{if this.isDisabled ' segmentation-item--disabled'}}"
      {{! @glint-expect-error: Incorrect type }}
      disabled={{this.isDisabled}}
      role="tooltip"
      {{on "mouseenter" (perform this.onMouseEnterTask)}}
      {{on "mouseleave" (perform this.onMouseLeaveTask)}}
    >
      <IncrementFor @times={{this.indentationAmount}} as |incrementIndex|>
        <div class="indent-container flex items-center justify-center">
          {{! Only show the expand arrow in last indentation level (incrementIndex is 0-based so we add 1) }}
          {{#if
            (and
              this.showExpandableArrow
              (eq this.indentationAmount (inc incrementIndex))
            )
          }}
            <div
              class="expand-arrow-icon-clickable-area"
              role="button"
              {{on "click" (fn this.toggleExpandedRow @item)}}
            >
              <GeneralButtonsButtonExpandArrow
                @isExpanded={{this.isExpanded}}
              />
            </div>
          {{/if}}
        </div>
      </IncrementFor>

      <button
        class="button--unstyled segmentation-data-container segmentation-data-container--indentation-{{this.indentationAmount}}
          {{unless @item.isSelectable 'cursor-default'}}"
        data-test-id={{@item.segmentationValueId}}
        disabled={{this.isDisabled}}
        type="button"
        {{on "click" (fn this.selectSegmentationItem @item)}}
      >
        {{#if this.showSimplifiedTemplate}}
          <div
            class="current-value
              {{if this.riSelections.isTargetActive 'current-value--target'}}"
          >
            <div class="title-and-value-container">
              <span
                class="progress-bar-title text-neutral-subdued"
              >{{@item.displayValue}}</span>
            </div>
            <div class="flex flex-row">
              <PrismDataBar />
            </div>
          </div>
          <div
            class="reference-value
              {{if
                this.riSelections.isCancellationsOnlyView
                'reference-value--target'
              }}"
          >
            <div
              class="title-and-value-container flex items-center justify-end"
            >
              {{#if this.riSelections.isTargetActive}}
                <span class="text-neutral-subdued">
                  {{t "revenue_insight.multi.budget.outside_top_200_text"}}
                </span>
              {{else if (not this.isSelected)}}
                <button
                  class="prism-link link-button--unstyled"
                  data-event-id="revenue-insight-filter-outside-top-200"
                  type="button"
                >
                  {{t "revenue_insight.breakdowns.filter_text"}}
                </button>
              {{/if}}
            </div>
          </div>
        {{else}}
          <HotelAndMarketRevenueInsightSegmentationSegmentationItemWithChange
            @activateSearch={{this.activateSearch}}
            @changeData={{this.changeData}}
            @hasTarget={{or
              this.hasTarget
              this.riSelections.isCancellationsOnlyView
            }}
            @isBudgetActive={{this.riSelections.isBudgetActive}}
            @isForecastActive={{this.riSelections.isForecastActive}}
            @isStriped={{this.riSelections.isCancellationsOnlyView}}
            @item={{@item}}
            @targetValue={{this.targetValue}}
            @targetValuePercentage={{this.targetValuePercentage}}
            @value={{this.formattedValueWithPercentage}}
            @valueColor={{this.valueColor}}
            @valueProgressBarData={{this.valueProgressBarData}}
            @vsBudgetText={{this.riSelections.vsBudgetText}}
            @vsForecastText={{this.riSelections.vsForecastText}}
            @vsReferencePeriodText={{this.vsReferencePeriodText}}
          />
        {{/if}}
      </button>
    </div>
    {{#if (and this.isHovered this.showTooltip)}}
      <EmberTooltip
        @isShown={{this.isHovered}}
        @side={{this.tooltipSide}}
        @tooltipClass="base-tooltip revenue-insight-segmentation-value-tooltip"
      >
        <HotelAndMarketRevenueInsightTooltipsTooltipRevenueInsight
          @data={{@item}}
          @hideTarget={{this.isPickup}}
          @kpis={{@params.visibleKpis}}
          @metricKey={{this.metricKey}}
          @section={{@params.section}}
        />
      </EmberTooltip>
    {{/if}}
  </template>
}
